//#region src/variants/variants_datepicker.js
var variants_datepicker_default = {
	default: {},
	"week starts monday": { props: { weekStartsOn: { initialValue: 1 } } }
};
//#endregion
export { variants_datepicker_default as default };

//# sourceMappingURL=variants_datepicker.js.map